






































































































import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { mapGetters } from 'vuex'
import { FavouriteLot, LotInfo } from '~/models'
import MaterialIcon from '@/components/shared/MaterialIcon.vue'
import LotImage from '@/components/consumer_map_v3/LotImage.vue'
import projectConfig from '~/assets/project-config.json'
import { LotTypes } from '~/enums/lots'
import LotUtilsMixin from '~/mixins/LotUtilsMixin'
import globalStyling from '~/mixins/globalStyling'
import {
  setLocalStorageFavouriteItem,
  isItemInFavs,
  storageAvailable,
} from '~/utils/localStorage'
import { favoritesStore } from '~/store'

@Component({
  components: {
    MaterialIcon,
    LotImage,
  },
  computed: {
    ...mapGetters('consumer-map', {
      isCustomBadgesEnabled: 'isCustomBadgesEnabled',
    }),
  },
  mixins: [LotUtilsMixin, globalStyling],
})
export default class InfoCardListItemV3 extends mixins(
  LotUtilsMixin,
  globalStyling
) {
  @Prop({ default: (): LotInfo => null })
  lotInfo: LotInfo

  isSaved: Boolean = false
  displayHomesiteBed: Boolean = true
  displayCustomCard: Boolean = false
  displayBed: Boolean = null
  displayBath: Boolean = null
  displaySqft: Boolean = null
  displaySize: Boolean = null
  displaySqFtLabel: boolean = false
  isCustomBadgesEnabled: Boolean

  favoriteWatch: any = null

  @Prop({ default: '' }) lotType: string

  get tag(): string {
    if (typeof this.lotInfo.builder === 'string') return 'unassigned'
    else if (this.lotInfo.status === 'coming soon') return 'coming soon'
    else if (this.lotType === LotTypes.HOME_SITE) {
      if (this.lotInfo.status === 'custom') return 'custom lot'
      else if (this.lotInfo.status === 'high profile') return 'high profile'
    } else if (this.lotType === LotTypes.HOME) {
      if (this.lotInfo.status === 'model') return 'model home'
      else if (this.lotInfo.sale_id) return 'sold'
    }
  }

  get virtualTour(): string {
    return (
      this.lotInfo?.architectural_submission?.master_plan?.plan
        ?.virtual_tour_url || null
    )
  }

  get customPriceLabel(): string {
    if (this.lotInfo?.property_type === 'Condo') {
      const label = projectConfig[this.$route.params.slug]?.condoPriceLabel
      if (label) return label
    }
    if (this.lotType === LotTypes.HOME_SITE)
      return (
        projectConfig[this.$route.params.slug]?.homesitePriceLabel ||
        'Sale Price'
      )

    return (
      projectConfig[this.$route.params.slug]?.homePriceLabel || 'Listing Price'
    )
  }

  get isStorageEnabled(): boolean {
    return storageAvailable()
  }

  lotPrice(lotInfo: any, lotType: string) {
    const price = this.price(lotInfo, lotType)
    const callForDetailsLabel =
      projectConfig[this.$route.params.slug]?.callForDetailsLabel || ''
    if (price.toLowerCase() === 'Call for Details'.toLowerCase()) {
      return callForDetailsLabel || price
    }
    return price
  }

  get badges() {
    // This is quickly adapted from the card badges.
    const badges: Array<string> = []

    if (this.lotType) {
      badges.push(this.getBadgeText(this.lotType))
    }
    return badges
  }

  getBadgeText(lotType: string): string {
    if (lotType === 'home') {
      return (
        this.getStyleVariableValue('--v3-cm-home-badge-label')?.replace(
          /['"]+/g,
          ''
        ) || 'Home to Buy'
      )
    } else {
      return (
        this.getStyleVariableValue('--v3-cm-homesite-badge-label')?.replace(
          /['"]+/g,
          ''
        ) || 'Lot to Build'
      )
    }
  }

  saveFav(lot: LotInfo) {
    if (!storageAvailable()) {
      return
    }
    const planId = lot?.architectural_submission?.master_plan?.plan?.id
    const elevationId = lot?.architectural_submission?.master_plan?.id

    const favObject: FavouriteLot = {
      id: String(lot.id),
      plan_id: planId ? String(planId) : null,
      elevation_id: elevationId ? String(elevationId) : null,
    }

    // this method adds or removes from local storage when needed
    setLocalStorageFavouriteItem(favObject, 'lot')

    if (this.isSaved) {
      favoritesStore.removeFavorite({ ...favObject, item_type: 'lot' })
    } else {
      favoritesStore.addFavorite({ ...favObject, item_type: 'lot' })
    }

    this.isSaved = !this.isSaved
  }

  mounted(): void {
    this.favoriteWatch = this.$store.watch(
      () => this.$store.getters['favorites/favCount'],
      (val, oldVal) => {
        if (storageAvailable()) this.updateSaved()
      }
    )
    if (storageAvailable()) this.updateSaved()
    this.initInfoCards()
  }

  initInfoCards() {
    const customCardType = this.getStyleVariableValue(
      '--ad-cm-lot-custom-card-type'
    )?.replace(/['"]+/g, '')
    if (this.lotInfo.property_type === customCardType) {
      this.displayCustomCard = true
      this.displayBed = this.isVisible('--ad-cm-lot-custom-card-beds')
      this.displayBath = this.isVisible('--ad-cm-lot-custom-card-baths')
      this.displaySqft = this.isVisible('--ad-cm-lot-custom-card-sqft')
      this.displaySize = this.isVisible('--ad-cm-lot-custom-card-size')
      this.displaySqFtLabel = this.isVisible(
        '--ad-cm-lot-custom-card-sqft-label'
      )
    } else {
      this.displayBed = this.isVisible('--ad-cm-lot-home-beds')
      this.displayBath = this.isVisible('--ad-cm-lot-home-baths')
      this.displaySqft = this.isVisible('--ad-cm-lot-home-sqft')
      this.displaySize = this.isVisible('--ad-cm-lot-homesite-size')
      this.displaySqFtLabel = this.isVisible('--ad-cm-lot-homesite-sqft-label')
      this.displayHomesiteBed = this.isVisible('--ad-cm-list-homesite-beds')
    }
  }

  formatLotSize(size: string): string {
    if (!this.displayCustomCard && !this.displaySqFtLabel) {
      return size
    }
    // Remove the ' character at the end
    size = size.replace(/'$/, '')

    // Add a comma after every third character from the right
    return size.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  unmounted(): void {
    this.favoriteWatch()
  }

  updateSaved() {
    const planId = this.lotInfo?.architectural_submission?.master_plan?.plan?.id
    const elevationId = this.lotInfo?.architectural_submission?.master_plan?.id

    const favObject: FavouriteLot = {
      id: String(this.lotInfo.id),
      plan_id: planId ? String(planId) : null,
      elevation_id: elevationId ? String(elevationId) : null,
    }
    this.isSaved = isItemInFavs(favObject, 'lot')
  }

  getColor() {
    const variable = this.isSaved ? '--cm-sp-fav-fill' : '--cm-sp-fav-outline'
    const color = this.getStyleVariableValue(variable)?.replace(/['"]+/g, '')
    if (color) return { color }
    return {}
  }
}
